// extracted by mini-css-extract-plugin
module.exports = {"mapDescription":"_21KUIW3UdkxzzH2c8hP2Qo"};